import { useLocation } from "react-router-dom";

/** Header'ın içeriğin üstünde yüzdüğü (saydam) rotalar. */
const FLOATING_ROUTES = new Set(["/"]);

/**
 * Anasayfada header saydam ve içeriğin üstünde yüzer: hero'nun ışık kümeleri
 * header'ın arkasına kadar uzanır, alt kenarda kesik oluşmaz. Kaydırıldığında
 * cam zemin geri gelir (MainLayout `data-scrolled` yazar, header CSS ile okur).
 * Bu rotadaki sayfa üst boşluğu (`pt-14`) kendisi bırakır.
 */
export const useFloatingHeader = (): boolean =>
  FLOATING_ROUTES.has(useLocation().pathname);
